import { AttendanceVoce } from "@/api/openapi";
import { showTranslated, translate } from "@/config/translator";
import { faCircleMinus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";
// eslint-disable-next-line max-len
import { useAttendanceVociListElement } from "./attendanceVociListElement/useAttendanceVociListElement";
import { VociDataEntry } from "./attendanceVociListElement/voceDataEntry";

type AttendanceVociListElementProps = {
  voce: AttendanceVoce;
  onRemove: () => void;
};

export function AttendanceVociListElement({
  voce,
  onRemove,
}: AttendanceVociListElementProps) {
  const { lang } = useAttendanceVociListElement();

  return (
    <div className="rounded-lg overflow-hidden border border-neutral shadow-sm">
      <div className="bg-canvas-secondary flex flex-row justify-between p-4">
        <div className="font-semibold text-base">
          {showTranslated(voce.name, lang)}
        </div>
        <button onClick={onRemove} className="cursor-pointer group">
          {
            <FontAwesomeIcon
              className={clsx(
                "text-primary",
                "group-hover:text-red-500",
                "duration-200",
                "ease-in-out",
                "text-xl",
              )}
              icon={faCircleMinus}
            />
          }
        </button>
      </div>
      <div className="flex flex-col gap-2 p-4">
        <VociDataEntry label={translate("quantity", lang)}>
          {voce.quantity}
        </VociDataEntry>
        <VociDataEntry
          label={translate(
            voce.voceType === "base_by_quantity" ? "base" : "amount",
            lang,
          )}
        >
          € {voce.base}
        </VociDataEntry>
      </div>
    </div>
  );
}
